import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48893c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#sidebar-navigation",
  class: "link"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "frontend-icon fi-fa_bars" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'side-bar-button',
  props: {
    padded: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["components__side-bar-button menu-button print--hide", {padded: __props.padded}])
  }, _hoisted_2, 2))
}
}

})